import type { Feature } from '@/userManagement/domain/entities/Feature';

export type FeatureCatalogEntry = Pick<
  Feature,
  | 'name'
  | 'category'
  | 'supportsRead'
  | 'supportsWrite'
  | 'supportsDelete'
  | 'supportsCentralAccess'
  | 'supportsExcelExport'
  | 'isActive'
  | 'isRemovedFromErp'
>;

export function featureCatalogMap(features: Feature[]): Map<number, FeatureCatalogEntry> {
  return new Map(
    features.map((f) => [
      f.id,
      {
        name: f.name,
        category: f.category,
        supportsRead: f.supportsRead,
        supportsWrite: f.supportsWrite,
        supportsDelete: f.supportsDelete,
        supportsCentralAccess: f.supportsCentralAccess,
        supportsExcelExport: f.supportsExcelExport,
        isActive: f.isActive,
        isRemovedFromErp: f.isRemovedFromErp
      }
    ])
  );
}
